module.exports = __webpack_public_path__ + "static/media/payment_icon.398831b1.svg";